{
  "apis": {
    "form": {
      "passport": {
        "scanUploadTitle": "Skannaa tai lataa passisi"
      }
    }
  },
  "checkIn": {
    "steps": {
      "apis": {
        "infoBox": {
          "ensureDetailsComplete": "Varmista, että tarvittavat tiedot on annettu ja että ne ovat oikein",
          "documentsPreChecked": "Matkustusasiakirjat on vahvistettu",
          "documentsNotChecked": "",
          "seeAgentOrPreCheck": "Asiakirjasi tarkistetaan lentokentällä.",
          "seeAgentOrPreCheckButton": "Vahvista verkossa ja säästä aikaa"
        }
      }
    }
  }
}
